import { createVNode as l, mergeProps as i } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MoreFilled.js";
import s from "../components/PfIcon.js";
const r = (e, o) => {
  const t = {
    ...e,
    ...o.attrs
  };
  return l(s, i(t, {
    icon: m
  }), null);
};
r.displayName = "MoreFilled";
r.inheritAttrs = !1;
export {
  r as default
};
